import { PropsWithChildren, ReactNode } from "react";

import { cn } from "@utils/ui";

import { Label } from "../../ui/label";

type FieldWrapperProps = {
  id: string;
  label?: string;
  subLabel?: string;
  isRequired?: boolean;
  errorMessage?: string;
  className?: string;
  childrenContainerClassName?: string;
  labelClassName?: string;
  labelContainerClassName?: string;
  labelRight?: ReactNode;
} & PropsWithChildren;
const FieldWrapper = ({
  id,
  label,
  subLabel,
  isRequired,
  errorMessage,
  children,
  className = "",
  childrenContainerClassName,
  labelClassName,
  labelContainerClassName,
  labelRight,
}: FieldWrapperProps) => {
  return (
    <div className={className}>
      <div className={cn("mb-2", labelContainerClassName)}>
        {(label || labelRight) && (
          <div className="flex items-center justify-between">
            {label && (
              // font-head (Montserrat) comes from Label itself; semibold
              // overrides its default font-medium.
              <Label
                htmlFor={id}
                className={cn("block text-sm font-semibold", labelClassName)}
              >
                {label} {isRequired && <span className="text-destructive">*</span>}
              </Label>
            )}
            {labelRight}
          </div>
        )}

        {subLabel && <p className="text-muted-foreground text-xs">{subLabel}</p>}
      </div>

      <div className={childrenContainerClassName}>{children}</div>

      {errorMessage && (
        <p className="mt-1 text-sm text-destructive">{errorMessage}</p>
      )}
    </div>
  );
};

export default FieldWrapper;
